import { FetchStoreData } from "../../../UserData/_actions/Store/StoreActions";
import useSuspenseData from "../useSuspenseData";

export default function useStoreData(storeSlug?: string) {
  return useSuspenseData({
    select: state => storeSlug
      ? state.get('userData').get('stores').find(store => store.get('slug') === storeSlug)
      : undefined,
    isReady: store => !store || store.get('details_loaded'),
    load: store => storeSlug && store ? FetchStoreData(storeSlug) : undefined,
  })
}
